export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avis de l'agent"])},
        "verdict": {
          "approve": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approuver"])},
          "refuse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refuser"])},
          "complement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Demander des compléments"])}
        },
        "more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir le détail"])},
        "less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Masquer le détail"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agent opinion"])},
        "verdict": {
          "approve": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approve"])},
          "refuse": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refuse"])},
          "complement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ask for more information"])}
        },
        "more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show details"])},
        "less": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hide details"])}
      }
    }
  })
}
